var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"overlay bg-dark"},[_c('div',{staticClass:"content h1 text-center"},[_c('span',{staticClass:"text-white"},[_vm._v(" "+_vm._s(_vm.loadingMessage)+" "),_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner"}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }